import React from "react";
import PhotoCardsLightbox from "components/PhotoCardsLightbox";

const Goals = props => {

  return (
    <section className="goals">
      <div className="info">
        <h1>Goals</h1>
        {props.spaceText(props.work.focus.goals.content)}
      </div>
      {(props.work.focus.goals.img !== null) && (
        <PhotoCardsLightbox images={[
          {url: `img/projects/${props.work.slug}/${props.work.focus.goals.img[0]}`},
          {url: `img/projects/${props.work.slug}/${props.work.focus.goals.img[1]}`}
        ]} />
      )}
    </section>
  )
}

export default Goals;